import { KnBrOccConfig } from 'src/app/config/kn-br-occ.config';

export const knBrCustomer360EndpointsConfig: KnBrOccConfig = {
  backend: {
    occ: {
      endpoints: {
        orderDetail: 'knbr/customers/${customerId}/orders/${orderId}?fields=FULL,entries(product(images(FULL)))',
        orderReturnDetail:
          'knbr/customers/${customerId}/orderReturns/${returnRequestCode}?fields=BASIC,returnEntries(BASIC,refundAmount(formattedValue),orderEntry(basePrice(formattedValue),product(name,code,baseOptions,images(DEFAULT,galleryIndex)))),deliveryCost(formattedValue),totalPrice(formattedValue),subTotal(formattedValue)',
        orderList: 'knbr/customers/${customerId}/orders',
        createReturnOrder: 'knbr/customers/${customerId}/orderReturns',
        reorder: 'knbr/customers/${customerId}/cartFromOrder',
        knbrCancelOrder: 'knbr/customers/${customerId}/orders/${code}/cancellation',
        orderFormProductSearch:
          'knbr/customers/${customerId}/orderforms?fields=products(code,name,summary,price(FULL),images(DEFAULT),stock(FULL),averageRating,variantOptions,uom,minOrderQuantity),sorts(FULL)',
        editOrder: 'knbr/customers/${customerId}/orders/${code}/editOrder',
      },
    },
  },
};
